import { useCallback, useEffect, useRef, useState } from "react";

import { useHookableRef } from "./useHookableRef";
import { useRerender } from "./useRerender";

import type { MutableRefObject } from "react";

/**
 * TODO
 */

export function useIntersectionObserver<T extends Element>(
  options?: IntersectionObserverInit,
): [MutableRefObject<T | null>, IntersectionObserverEntry | undefined] {
  const rerender = useRerender();

  const [element, setElement] = useState<T | null>(null);
  const elementRef = useHookableRef<T | null>(null, (v) => {
    setElement(v);
    return v;
  });

  const entryRef = useRef<IntersectionObserverEntry>();

  const measure = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      if (element) {
        entryRef.current = entries[0];
      }
    },
    [element],
  );

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      measure(entries);
      rerender();
    }, options);

    observer.observe(element);

    return () => {
      observer.unobserve(element);
      observer.disconnect();
    };
  }, [element, measure, options, rerender]);

  return [elementRef, entryRef.current];
}
